import React from 'react'
import {
  HouseIcon,
  BellRingIcon,
  SettingsIcon,
  LogoutIcon,
  MediaIcon,
  sentinelUrl,
  backhaulUrl,
  lookoutUrl,
  waveUrl,
  FileUploadIcon,
  MessageCircleIcon,
} from '../images'
import { Permissions } from 'hooks/useHasPermission'

const MAIN_NAV_ICON_WIDTH = '20px'
const MAIN_NAV_ICON_WIDTH_LARGER = '24px'
const MAIN_NAV_ICON_WIDTH_PNG = '24px'
const MOBILE_NAV_ICON_WIDTH = '20'

export const MAIN_NAV = [
  {
    key: 'dashboard',
    path: '/',
    icon: <HouseIcon width={MAIN_NAV_ICON_WIDTH} />,
    permissionName: Permissions.dashboard,
    flexAlignClass: 'align-items-end',
    style: { marginBottom: '-2px', paddingRight: '2px', paddingLeft: '2px' },
  },
  {
    key: 'demandPrediction',
    path: '/events',
    icon: <img alt="lookout" src={lookoutUrl} width={MAIN_NAV_ICON_WIDTH_LARGER} />,
    permissionName: Permissions.lookout,
  },
  {
    key: 'recommendations',
    path: '/campaigns',
    icon: <img alt="wave" src={waveUrl} width={MAIN_NAV_ICON_WIDTH_LARGER} />,
    permissionName: Permissions.wave,
  },
  {
    key: 'package-builder',
    path: '/package-builder',
    icon: <img alt="backhaul" src={backhaulUrl} width={MAIN_NAV_ICON_WIDTH_LARGER} />,
    permissionName: Permissions.backhaul,
  },
  {
    key: 'sentinel',
    path: '/sentinel',
    permissionName: Permissions.sentinel,
    icon: <img alt="sentinel" src={sentinelUrl} width={MAIN_NAV_ICON_WIDTH_LARGER} />,
  },
]

export const MAIN_NAV_MIDDLE = [
  {
    key: 'library',
    path: '/library',
    icon: <MediaIcon width={MAIN_NAV_ICON_WIDTH} height={MAIN_NAV_ICON_WIDTH} />,
    style: { padding: '2px', paddingLeft: '2px' },
  },
  {
    key: 'fileUpload',
    icon: <FileUploadIcon width={MAIN_NAV_ICON_WIDTH} />,
    navType: 'modal',
    style: { paddingRight: '2px', paddingLeft: '2px' },
  },
]

export const MAIN_NAV_BOTTOM = [
  {
    key: 'notifications',
    path: '/notifications',
    icon: <BellRingIcon width={MAIN_NAV_ICON_WIDTH} />,
    style: { paddingRight: '2px', paddingLeft: '2px' },
  },
  {
    key: 'settings',
    path: '/settings',
    icon: <SettingsIcon width={MAIN_NAV_ICON_WIDTH} />,
    style: { paddingRight: '2px', paddingLeft: '2px' },
  },
  {
    key: 'support',
    href: 'https://support.future-demand.com',
    external: true,
    icon: <MessageCircleIcon width={MAIN_NAV_ICON_WIDTH} />,
    style: { paddingRight: '2px', paddingLeft: '2px' },
  },
  {
    key: 'logout',
    path: null,
    icon: <LogoutIcon width={MAIN_NAV_ICON_WIDTH} />,
    style: { paddingRight: '2px', paddingLeft: '2px' },
  },
]

export const MOBILE_NAV = [
  {
    key: 'dashboard',
    path: '/',
    icon: <HouseIcon width={MOBILE_NAV_ICON_WIDTH} />,
    permissionName: Permissions.dashboard,
    style: { paddingLeft: '2px', paddingRight: '2px' },
  },
  {
    key: 'demandPrediction',
    path: '/events',
    icon: <img alt="lookout" src={lookoutUrl} width={MAIN_NAV_ICON_WIDTH_PNG} />,
    permissionName: Permissions.lookout,
  },
  {
    key: 'salesBoost',
    path: '/campaigns',
    icon: <img alt="wave" src={waveUrl} width={MAIN_NAV_ICON_WIDTH_PNG} />,
    permissionName: Permissions.wave,
  },
  {
    key: 'package-builder',
    path: '/package-builder',
    icon: <img alt="backhaul" src={backhaulUrl} width={MAIN_NAV_ICON_WIDTH_PNG} />,
    isPreview: false,
    permissionName: Permissions.backhaul,
  },
  {
    key: 'sentinel',
    path: '/sentinel',
    icon: <img alt="sentinel" src={sentinelUrl} width={MAIN_NAV_ICON_WIDTH_PNG} />,
    permissionName: Permissions.sentinel,
  },
]

export const MOBILE_NAV_MIDDLE = [
  {
    key: 'library',
    path: '/library',
    icon: <MediaIcon width={MOBILE_NAV_ICON_WIDTH} />,
    style: { paddingLeft: '2px', paddingRight: '2px' },
  },
  {
    key: 'fileUpload',
    path: '/fileUpload',
    icon: <FileUploadIcon width={MOBILE_NAV_ICON_WIDTH} />,
    style: {
      paddingLeft: '2px',
      paddingRight: '2px',
    },
  },
]

export const MOBILE_NAV_BOTTOM = [
  {
    key: 'notifications',
    path: '/notifications',
    icon: <BellRingIcon width={MOBILE_NAV_ICON_WIDTH} />,
    style: {
      paddingLeft: '2px',
      paddingRight: '2px',
    },
  },
  {
    key: 'settings',
    path: '/settings',
    icon: <SettingsIcon width={MOBILE_NAV_ICON_WIDTH} />,
    style: {
      paddingLeft: '2px',
      paddingRight: '2px',
    },
  },
  {
    key: 'support',
    href: 'https://support.future-demand.com',
    external: true,
    icon: <MessageCircleIcon width={MOBILE_NAV_ICON_WIDTH} />,
    style: {
      paddingLeft: '2px',
      paddingRight: '2px',
    },
  },
  {
    key: 'logout',
    path: null,
    icon: <LogoutIcon width={MOBILE_NAV_ICON_WIDTH} />,
    style: {
      paddingLeft: '2px',
      paddingRight: '2px',
    },
  },
]

export const DEFAULT_EVENT_CATEGORY = 'all'
